'use client'

import dynamic from 'next/dynamic'
import {
  useEffect,
  useState,
  type ComponentType,
  type ReactNode,
} from 'react'

type ImportedModule =
  | { default: ComponentType<any> }
  | ComponentType<any>

/**
 * `next/dynamic(..., { ssr: false })` yerine kullan.
 * BailoutToCSR ("Bail out to client-side rendering: next/dynamic") üretmez:
 * sunucuda/hydration öncesi fallback, mount sonrası chunk yüklenir.
 */
export function clientOnlyDynamic(
  loader: () => Promise<ImportedModule>,
  options?: { loading?: () => ReactNode },
): ComponentType<any> {
  const Lazy = dynamic(
    () =>
      loader().then((mod) => {
        if (typeof mod === 'function') {
          return { default: mod }
        }
        return { default: mod.default }
      }),
    {
      loading: options?.loading,
    },
  )

  function ClientOnlyDynamic(props: any) {
    const [ready, setReady] = useState(false)
    useEffect(() => {
      setReady(true)
    }, [])
    if (!ready) {
      return <>{options?.loading?.() ?? null}</>
    }
    return <Lazy {...props} />
  }

  ClientOnlyDynamic.displayName = 'ClientOnlyDynamic'
  return ClientOnlyDynamic
}
